/**
 * product-native-video.js
 *
 * Plays a Shopify-hosted (native) product video when its gallery modal opens,
 * and pauses + rewinds it when the modal closes.
 *
 * Why this exists: the theme's Modal class resets video modals with
 * `e.target.querySelector("iframe")` and then writes to `.parentNode`. A native
 * <video> would make that querySelector return null and throw on close, so
 * native videos use `Modal--nativeVideoContent` (skipped by that reset logic)
 * and are handled here instead.
 */
(function () {
  var OPEN = 'false'; // the theme marks an open modal as aria-hidden="false"

  function bind(modal) {
    var video = modal.querySelector('video');
    if (!video) return;

    function sync() {
      if (modal.getAttribute('aria-hidden') === OPEN) {
        var attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') {
          // Autoplay with sound can still be blocked by the browser;
          // the native controls stay available either way.
          attempt.catch(function () {});
        }
      } else {
        video.pause();
        video.currentTime = 0;
      }
    }

    new MutationObserver(sync).observe(modal, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });

    // The theme's _checkOpenByHash() can open a modal before this script runs
    // (e.g. /products/x#modal-video-123), so honour the current state too.
    if (modal.getAttribute('aria-hidden') === OPEN) sync();
  }

  function init() {
    var modals = document.querySelectorAll('.Modal--nativeVideoContent');
    for (var i = 0; i < modals.length; i++) bind(modals[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
